/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType extends models.WellArchitectedFrameworkAssessmentNotificationWebHook {
    constructor() {
        super();
        this.setDiscriminator("WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType");
    }

    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType>): WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType(), model);
        WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType>): WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType.newInstance(<WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType): boolean {
        if (models.WellArchitectedFrameworkAssessmentNotificationWebHook.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
